<template>
    <div class="signin-bg">
        <Header></Header>
        <!--搜索-->
        <div class="gjcpubuliu" v-if="!isLoad">
            <div class="w-1190" v-if="isResult">
                <!--关键词-->
                <div class="nav-top flbt">
                    <div class="gjc-font">
                        <span class="serch-gjc" style="font-weight: 600">{{searchList.title}}</span>
                    </div>
                </div>
                <div class="nav-top flbt">
                    <div class="gjc-font">
                        <span class="jieguo-num">{{searchList.imgs.length}}</span>
                        <span>个作品</span>
                    </div>
                </div>
                <!--图片瀑布流-->
                <div class="pubu-img">
                    <ul>
                        <li v-for="(item,index) in searchList.imgs" :key="index" :style="{width:(200/item.height)*item.width + 'px',background:'#bbbbbb'}">
                            <router-link :to="{name:'Photo',query:{id:item.id}}" target="_blank">
                                <img :src="item.src"/>
                            </router-link>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <loading v-if="isLoad"></loading>
        <Footer></Footer>
    </div>
</template>

<script>
    import Header from './Header';
    import Footer from './Footer';
    import Pagination from '../components/Pagination';
    export default {
        name: 'Special_detail',
        data() {
            return {

                keyword:'',
                currentPage:1,
                contributor_handle:'',
                searchList:[],
                isLoad:false,
                isResult:false,
                searchList2:[],
                user_name:'',
                author:'',
                user_id:'',
                register_time:'',
                name:'',
                email:'',
                contact_person:'',
                s_id:" ",
            }
        },
        components:{
            Header,
            Footer,
        },
        created() {
            this.s_id = this.$route.query.s_id
            document.getElementsByTagName("title")[0].innerText = '神笔pro - '+this.author+'的作品集'
            this.$get('/me')
                .then( res => {
                    if(res.code == 200){
                        this.user_name = res.data.user.user_name
                        this.user_id = res.data.user.id
                        this.register_time = res.data.user.created_at
                        this.name = res.data.user.name
                        this.email = res.data.user.email
                        this.contact_person = res.data.user.contact_person
                    }
                }).catch(error => {
                console.log(error)
            })
        },
        mounted() {
            this.getSearchList()
        },
        methods: {
            getSearchList(currentPage){
                this.isResult = false
                this.isLoad = true
                this.$get('/topic/'+ this.s_id, )
                    .then( res => {
                        this.searchList = { page: 0, pages: 0, perpage: 0, total: 0, image: [] }
                        if(res.code == 200){
                            this.isLoad=false
                            if(res.data.result.imgs.length > 0){
                                this.isResult=true
                                this.searchList = res.data.result
                            }
                        }else{
                            this.$message({
                                message: res.message,
                                type: 'error'
                            });
                        }

                    }).catch(errors => {
                       console.log(errors);
                })

            },
        }
    }
</script>


<style scoped>
    body {  font-family: "Source Han Sans CN",Arial,sans-serif;  font-size: 16px;  }
    * {  padding: 0; margin: 0; box-sizing: border-box; }
    a {text-decoration: none;color:#333;  }
    div, b, p, h1, h2, h3, h4, h5, h6,ul, li, dl, dd, header, footer {  margin: 0;  padding: 0;  list-style: none;  }
    em, i, b, strong {font-style: normal;font-weight: normal;}
    .ct{text-align: center;}
    .fl{float: left}
    .fr{float: right}
    .pr{position: relative}
    .pa{position: absolute;z-index: 99}
    .hd{overflow: hidden;}
    .flard{display: flex;justify-content: space-around;}
    .flbt{display: flex;justify-content: space-between;}
    .w-1200{width: 1200px;margin: 0 auto;}
    .w-1190{width: 1190px;margin: 0 auto;}
    .mt25{margin-top: 25px}
    /*ͷ������*/
    img{vertical-align: top;}
    .header .logo{margin-top: 16px;}
    .nav li{margin: 0 20px;text-align: center;}
    .nav li.active::after{content:"";display:block;background: #FF9F00;height: 2px;width:80%;margin: -15px auto 0; }
    .nav li.active{font-weight: 600;}
    .loging .kefu img,.loging .tishi img{margin: 17px 20px 0;}
    .tishi{position: relative;}
    .tishi span.num{position: absolute;background: #E74C3A;border-radius:10px;color: #fff;min-width: 20px;height: 20px;font-size: 14px;text-align: center;line-height: 20px;display: inline-block;top:15px;right: 15px;padding: 0 4px;}
    .loging .user-down img{margin: 30px 10px 0}
    .user-down{cursor: pointer;position: relative;}

    .jiantou{ transform: rotate(180deg); -webkit-transform: rotate(180deg)}
    /*�ײ�*/
    footer{height: 180px;background: #fff;padding: 70px 0 0;}
    footer p{font-size: 12px;color: #999;text-align: center;}
    .serch{background: #f7f7f7;display: flex;justify-content: space-between;height: 50px;border-bottom: 2px solid #1F1F1F; position: relative;}
    .xiala{font-size: 16px;}
    .xiala:hover > .dropdown_menu{display: block}
    .dropdown{width: 140px;text-align: center;line-height: 48px;cursor: pointer;}
    .inpt{width: 950px;padding-right: 10px;position: relative;}
    input{border: none;height: 48px;line-height: 48px;width: 100%;/*padding-left:40px;*/outline:none;font-size: 16px;background: #f7f7f7;}
    input::-webkit-input-placeholder {color:#999999; font-size: 16px; }
    input:-moz-placeholder {color:#999999; font-size: 16px; }
    input::-moz-placeholder {color:#999999;font-size: 16px;  }
    input:-ms-input-placeholder {color:#999999; font-size: 16px; }
    .icon-scrch{width: 110px;text-align: center;cursor: pointer;}
    .icon-scrch img{margin-top: 13px;cursor: pointer;}
    /*������*/
    .xiala img{margin-top: 17px;}
    .inpt img{margin-top: 12px;position: absolute;}
    .dropdown {position: relative;}
    .dropdown_menu {display: none;background: #f7f7f7;position: absolute;top:48px;right: 30px;z-index: 1000;width: 110px;padding:10px 0;text-align: center;border-top: 1px solid #ddd;}
    .dropdown_menu dd{line-height: 34px!important;}
    .dropdown_menu dd:hover{background: #e0e0e0;}
    .dropdown dl dd a {color: #333;line-height: 34px;font-size:14px;}
    .top-arrow1,.top-arrow2 {width:0;height:0;display:block;position:absolute;left:30px;top:-17px;z-index:5; /*����ie8-*/ border-top:8px transparent dashed;border-left:6px transparent dashed;border-right:6px transparent dashed;border-bottom:8px white solid;overflow:hidden;}
    .top-arrow1 {border-bottom:9px #ddd solid;}
    .top-arrow2 {top:-15px;border-bottom:9px #f7f7f7 solid;}
    /*��������*/
    .continer{padding: 30px 0 15px;}
    .paixu{width: 200px;}
    .tiaojian{width: 980px;}
    .paixu p{float:left;margin-right: 15px;cursor: pointer;}
    .paixu .act{font-weight: 600; }
    .paixu .act i{display:block;height: 2px;width:28px;margin: 2px auto 0px;background: #000; }
    .tiaojian div.fl{margin-right: 30px;}
    .sxall{cursor: pointer;height: 30px;}
    .sxall p{display: inline-block;}
    .sxall img{vertical-align: middle;margin-left: 5px;}
    .tj-dow{background: #fff;top:30px;left: 0;width:110px;border: 1px solid #ddd;display: none;}
    .tj-dow a{display: block;height: 36px;line-height: 36px;}
    .tj-dow a:hover{background: #ddd;}
    .sxall:hover > .tj-dow{
        display: block;
    }
    .gjcpubuliu{background: #F7F7F7;padding: 30px 0;}
    .nav-top{margin:0 5px 20px;}
    .serch-gjc{display: inline-block;margin-right: 20px;}
    .jieguo-num{font-weight: 600;display: inline-block;margin: 0 3px;}
    .page{font-size: 14px;}
    .page .dqye{width: 50px;border-bottom: 1px solid #000000;text-align: center;font-weight: 600;}
    .zuo img,.you img{width: 14px;height: 14px;cursor: pointer;}
    .you img{transform: rotate(180deg); -webkit-transform: rotate(180deg)}
    .allpage{margin: 0 10px;}
    .pubu-img{
        display: flex;
        flex-wrap: wrap;
        overflow: hidden;
    }
    .pubu-img ul{
        display: flex;
        flex-wrap: wrap;
    }
    .pubu-img ul li{
        flex-grow: 1;
        margin: 4px;
        height: 200px;
    }
    .pubu-img ul li:last-child{
        flex-grow: unset;
    }
    .pubu-img ul img{
        height: 200px;
        object-fit: cover;
        max-width: 100%;
        min-width: 100%;
        vertical-align: bottom;
    }
    .btn{width:285px;margin: 0 auto }
    .btn a{display: inline-block;width: 130px;height: 40px;line-height: 40px;border-radius: 23px;text-align: center;border: 1px solid#000;font-size:18px;margin: 0 5px;}
    .page-btm{margin-top: -30px;}
    .gjc-btm{margin-top: 60px;}
    .gjc-btm p{font-size: 18px;font-weight: 600;margin-bottom: 25px;}
    .gjc-contbg a{float:left;background: #fff;height: 30px;line-height: 30px;padding: 0 10px;border-radius: 5px;font-size: 14px;color: #999;margin-right: 8px;margin-bottom: 10px;}

    .ul-tag{
        width: 1200px;
        margin: 0 auto;
        display: flex;
    }
    .ul-tag li{
        margin: 0 5px 10px;
    }
    .ul-tag li span{
        position: relative;
        background-color: #f4f4f5;
        color: #909399;
        display: inline-block;
        width: auto;
        height: 36px;
        line-height: 36px;
        border-radius: 4px;
        font-size: 14px;
        padding: 0px 30px 0px 15px;
    }
    .ul-tag li span i{
        position: absolute;
        content: 'x';
        display: inline-block;
        font-size: 18px;
        right: 15px;
        cursor: pointer;
    }
    .camera-btn {
        position: absolute;
        top: -3px;
        right: 0;
        cursor: pointer;
        width: 36px;
        height: 36px;
    }
    .upload-box {
        position: absolute;
        top: 45px;
        right: 0;
        width: 500px;
        background: white;
        z-index: 999;
    }
    .upload-box .search-btn {
        padding: 10px;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .upload-box .search-btn .search-txt {
        display: flex;
        align-items: center;
    }
    .upload-box .search-btn .search-txt span {
        margin: 0 8px;
        word-break: break-all;
    }
    .upload-box .search-btn .el-button {
        background: #FF9F00;
        color: white;
        border: 0;
        padding: 12px 20px;
    }
</style>
<style>
.serch .el-upload-dragger {
    width: 500px !important;
    border-radius: 0 !important;
}
.serch .el-upload:focus .el-upload-dragger{border-color:#2e2e2e}
.serch .el-upload-dragger:hover {
    border: 1px dashed #2e2e2e;
}
.serch .el-upload-dragger .el-upload__text em {
    color: #2e2e2e;
    font-weight: bold;
    font-size: 16px;
}
.upload-box .el-loading-spinner i {
    color: #FF9F00;
}
.upload-box .el-loading-spinner .el-loading-text {
    color: #FF9F00;
}
</style>
